import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

export interface ISecurityTag {
  key: string;
  value: string;
  link?: string;
}

@Component({
  selector: 'app-security-tag',
  standalone: true,
  templateUrl: './security-tag.component.html',
  styleUrls: ['./security-tag.component.scss'],
  imports: [CommonModule],
})
export class SecurityTagComponent {
  @Input() public tags: ISecurityTag[];
}
